export enum GatewayStatus {
  UNKNOWNGATEWAYSTATUS = 'UNKNOWN_GATEWAY_STATUS',
  UNINITIALIZED = 'UNINITIALIZED',
  RUNNING = 'RUNNING',
  SUSPENDED = 'SUSPENDED'
}
